import React from 'react';
import { Query } from 'react-apollo';
import Edit from '@material-ui/icons/Edit';
import Button from '@material-ui/core/Button';
import { navigate } from '@reach/router';
import { GET_MY_PRODUCTS } from '../../queries';
import classes from './edit-product.module.scss';
import Card from '../card/card';

const AddProduct = () => (
  <Button
    color="secondary"
    variant="contained"
    style={{
      margin: '20px 15px 5px',
      textTransform: 'none'
    }}
    onClick={() => navigate('/add-product')}
  >
    Додати пропозицію
  </Button>
);

const ManageProducts = () => (
  <Query query={GET_MY_PRODUCTS}>
    {({ loading, error, data }) => {
      if (loading) {
        return <div>Loading...</div>;
      }
      if (error) {
        return <div>{error.message}</div>;
      }
      return data.myProducts.length ? (
        <div>
          <h2>Мої пропозиції</h2>
          <div
            style={{
              padding: '10px',
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap'
            }}
          >
            {data.myProducts.map(
              ({ id, imagesUrls, price, name, reviews, stars }: any) => (
                <div className={classes.card} key={id}>
                  <Card
                    card={{
                      id,
                      name,
                      label: name,
                      image: imagesUrls && imagesUrls.length && imagesUrls[0],
                      price,
                      reviews,
                      stars
                    }}
                    icon={
                      <div title="Редагувати">
                        <Edit onClick={() => navigate(`/edit-product/${id}`)} />
                      </div>
                    }
                  />
                </div>
              )
            )}
          </div>
          <AddProduct />
        </div>
      ) : (
        <div
          style={{
            textAlign: 'center',
            padding: '100px 0'
          }}
        >
          <div>У вас немає продуктів.</div>
          <AddProduct />
        </div>
      );
    }}
  </Query>
);

export default ManageProducts;
